/** @jsxRuntime classic */
/** @jsx jsx */
import { Button } from '@bottlebooks/gatsby-theme-base/src';
import type { ComponentPropsWithoutRef } from 'react';
import { jsx } from 'theme-ui';

export type IconButtonProps = Omit<
  ComponentPropsWithoutRef<typeof Button>,
  'sx'
>;

export default function IconButton({ children, ...rest }: IconButtonProps) {
  return (
    <Button
      sx={{
        display: 'flex',
        gap: 2,
        justifyContent: 'center',
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
